import { gql } from "apollo-boost";

const UPDATE_VENDOR_FORM_LABEL = gql`
  mutation updateVendorFormLabel($input: VendorFormLabelData) {
    updateVendorFormLabel(input: $input) {
      status
      data
      error
    }
  }
`;

export default UPDATE_VENDOR_FORM_LABEL;
